import { BookingRequestDetails } from "features/types";
import { post } from "services/http";
import { ReserveOrRedeemItem } from "./ticket.queries";

interface CreateBookingRequestParams {
  eventId: number;
  planPackageId: number;
  items: ReserveOrRedeemItem[];
  complimentary: boolean;
}

interface CreateDeferredBookingRequestParams {
  eventId: number;
  planPackageId: number;
  items: ReserveOrRedeemItem[];
  quantity: number;
  complimentary: boolean;
}

export const requestBookingRequest = (params: CreateBookingRequestParams) => {
  return post<BookingRequestDetails[]>({
    url: "/booking_request",
    params,
  });
};

export const requestDeferredBookingRequest = (
  params: CreateDeferredBookingRequestParams,
) => {
  return post<BookingRequestDetails>({
    url: "/booking_request",
    params,
  });
};
